import React, { createContext } from 'react'
import PropTypes from 'prop-types'
import { Theme, whiteTheme } from '..'

export const WhiteThemeContext = createContext(false)

export default function WhiteTheme({ children, as = 'div', ...props }) {
  return (
    <Theme as={as} theme="day" {...props} transparent>
      {/**
       *`data-is-white-theme` allows for internal-packages to know about the white theme,
       * but without having to have a direct dependency on ZionUI
       * For example, `Link` in @fs/zion-router-base needs WhiteTheme styles, but can't
       * have a direct dependency on ZionUI, otherwise we get circular dependencies.
       *
       * EVERYONE ELSE SHOULD JUST USE THE WhiteThemeContext CONTEXT, where needed.
       */}
      <div className={whiteTheme} data-is-white-theme>
        <WhiteThemeContext.Provider value>{children}</WhiteThemeContext.Provider>
      </div>
    </Theme>
  )
}

WhiteTheme.propTypes = {
  /** Enclosing tag name. */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),

  /** Any typography components within this component's children will have white text. */
  children: PropTypes.node.isRequired,
}
